"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var ExportedEntity_1 = require("../../export/model/ExportedEntity");

var ExportedEntityState_1 = require("../../export/model/ExportedEntityState");

var UserInfo_1 = require("../../user/model/UserInfo");

var ReleaseExportType_1 = require("./ReleaseExportType");
/**
 * Representation of the release in export queue.
 *
 * @author Radek Beran
 * @author VRu
 */


var ExportedRelease =
/*#__PURE__*/
function (_ExportedEntity_1$Exp) {
  _inherits(ExportedRelease, _ExportedEntity_1$Exp);

  /**
   * Creates new exported release.
   * @param id identifier of record in the queue
   * @param entityId id of release
   * @param exportType type of release export
   * @param state state of export
   * @param created time of creation of record
   * @param createdBy user who created this record
   * @param lastModified time of last modification of this record
   * @param nextAttempt time of next planned export attempt
   * @param attemptCount count of attempts, starts with 0; 1 after first successful of failed attempt
   * @param idbWriteAttemptCount count of attempts to write data to IDB
   * @param requestId request id returned from IDB
   * @param error description of last error if this record is in failed state
   * @param filePath path to file with exported prices
   * @param processId ID of application instance that is responsible for export
   */
  function ExportedRelease(id, entityId, exportType, state, created, createdBy, lastModified, nextAttempt, attemptCount, idbWriteAttemptCount, requestId, error, filePath, processId) {
    var _this;

    _classCallCheck(this, ExportedRelease);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ExportedRelease).call(this, id, state, created, createdBy, lastModified, nextAttempt, attemptCount, requestId, error, processId));
    _this.id = id;
    _this.entityId = entityId;
    _this.exportType = exportType;
    _this.state = state;
    _this.created = created;
    _this.createdBy = createdBy;
    _this.lastModified = lastModified;
    _this.nextAttempt = nextAttempt;
    _this.attemptCount = attemptCount;
    _this.idbWriteAttemptCount = idbWriteAttemptCount;
    _this.requestId = requestId;
    _this.error = error;
    _this.filePath = filePath;
    _this.processId = processId;
    return _this;
  }

  return ExportedRelease;
}(ExportedEntity_1.ExportedEntity);

exports.ExportedRelease = ExportedRelease;

ExportedRelease.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ExportedRelease.name);
  return {
    id: builder.id('id'),
    entityId: builder.id('entityId'),
    exportType: builder.senum('exportType', ReleaseExportType_1.ReleaseExportType, 'seq'),
    state: builder.senum('state', ExportedEntityState_1.ExportedEntityState, 'seq'),
    created: builder.date('created', DateParser_1.DateParser.ISO_PATTERN),
    createdBy: builder.obj('createdBy', UserInfo_1.UserInfo.schema, function (mat) {
      return new UserInfo_1.UserInfo(mat.id, mat.name);
    }),
    lastModified: builder.date('lastModified', DateParser_1.DateParser.ISO_PATTERN),
    nextAttempt: builder.date('nextAttempt', DateParser_1.DateParser.ISO_PATTERN),
    attemptCount: builder.num('attemptCount'),
    idbWriteAttemptCount: builder.num('idbWriteAttemptCount'),
    requestId: builder.opt(builder.num('requestId')),
    error: builder.opt(builder.str('error').withDescription({
      multiline: true
    })),
    filePath: builder.opt(builder.str('filePath')),
    processId: builder.opt(builder.str('processId'))
  };
}();